export default __webpack_public_path__ + "static/media/Mezzanine-Floor-1.3a2401ac.jpg";